<template>
  <Transition name="cookie-consent-fade">
    <div
        v-if="isVisible"
        aria-live="polite"
        class="cookie-consent-banner"
        role="status"
    >
      <p class="cookie-consent-banner__text">
        Используя сайт, вы соглашаетесь на обработку <a
          class="cookie-consent-banner__link"
          href="/documents/consent-personal-data/"
          rel="noopener noreferrer"
          target="_blank"
      >персональных данных</a> с использованием cookie, включая Яндекс.Метрику
      </p>

      <button
          v-if="!isMobile"
          class="cookie-consent-banner__ok"
          type="button"
          @click="dismiss('ok_click')"
      >
        ОК
      </button>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
const {isVisible, isMobile, dismiss} = useCookieConsent();
</script>

<style lang="scss" scoped>
.cookie-consent-banner {
  position: fixed;
  left: 16px;
  bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  z-index: 900;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 448px;
  max-width: 448px;
  padding: 8px 16px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);

  @include media(sm) {
    left: 8px;
    right: 8px;
    width: auto;
    max-width: none;
    border-radius: 20px;
    padding: 8px 16px;
  }

  &__text {
    flex: 1 1 auto;
    margin: 0;
    font-family: Ubuntu, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 1.4;
    color: $color-on-accent;

    @include media(sm, min-width) {
      flex: 1 1 354px;
      max-width: 354px;
    }

    @include media(sm) {
      flex: 1 1 auto;
      max-width: none;
      font-size: 10px;
      line-height: 1.2;
      text-align: center;
    }
  }

  &__link {
    color: inherit;
    text-decoration: underline;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    &:hover {
      opacity: 0.9;
    }
  }

  &__ok {
    flex-shrink: 0;
    width: 50px;
    margin: 0;
    padding: 12px 0;
    border: 1px solid $color-on-accent;
    border-radius: 50px;
    background: transparent;
    font-family: Ubuntu, sans-serif;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.2;
    color: $color-on-accent;
    white-space: nowrap;
    text-align: center;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.9;
    }
  }
}

.cookie-consent-fade-enter-active,
.cookie-consent-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.cookie-consent-fade-enter-from,
.cookie-consent-fade-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
